
// 不显示 Text2SQL菜单的白名单
export const HOSTNAMES = [
  'databrain.intlgame.com',
  'databrain.woa.com',
  'databrain-global.intlgame.com',
  'databrain-global.woa.com',
];
